module.exports = "<div class=\"cd-card cd-card--fixed\">\r\n  <header class=\"cd-card__header\">\r\n    <span>{{ heading }}</span>\r\n    <span class=\"cd-card__hint\">Sorted by complaint rate</span>\r\n  </header>\r\n  <div class=\"cd-grid\">\r\n    <ag-grid-angular class=\"compact-menu\" [gridOptions]=\"grid\"></ag-grid-angular>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-rank-table/dashboard-rank-table.component.html
// module id = 2416
// module chunks = 66